var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.68264 6.30879C8.05063 5.67705 7.19361 5.32216 6.3 5.32216C5.4064 5.32216 4.54937 5.67705 3.91736 6.30879L1.53396 8.69143C0.901938 9.32344 0.546875 10.1806 0.546875 11.0744C0.546875 11.9683 0.901938 12.8255 1.53396 13.4575C2.16597 14.0895 3.02317 14.4446 3.91698 14.4446C4.81078 14.4446 5.66798 14.0895 6.3 13.4575L7.49132 12.2662M6.3 8.69143C6.93201 9.32317 7.78903 9.67806 8.68264 9.67806C9.57624 9.67806 10.4333 9.32317 11.0653 8.69143L13.4487 6.30879C14.0807 5.67677 14.4358 4.81957 14.4358 3.92577C14.4358 3.03196 14.0807 2.17476 13.4487 1.54274C12.8167 0.910727 11.9595 0.555664 11.0657 0.555664C10.1719 0.555664 9.31465 0.910727 8.68264 1.54274L7.49132 2.73406",
    stroke: "#133F7D",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkIcon);
export default __webpack_public_path__ + "static/media/link_icon.db7aa1c803d2e3636c685b5d62efff22.svg";
export { ForwardRef as ReactComponent };